import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=c064a0ea&scoped=true&"
import script from "./FileSelect.vue?vue&type=script&lang=js&"
export * from "./FileSelect.vue?vue&type=script&lang=js&"
import style0 from "./FileSelect.vue?vue&type=style&index=0&id=c064a0ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c064a0ea",
  null
  
)

export default component.exports